/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.6",
    versionName: "0.2.0-nightly.2026.4.6",
    versionChannel: "nightly",
    buildDate: "2026-04-06T00:13:29.307Z",
    commitHash: "dbfcb9ab0e815189eef155bdfa1fc9c36c2bbdfd",
};
